import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try { setSent((await api.post("/auth/forgot-password", { email })).data.message); }
    catch (err) { setError(errorMessage(err)); }
    finally { setBusy(false); }
  };

  return (
    <main className="max-w-md mx-auto px-4 py-16">
      <div className="rise rounded-3xl bg-[#151C2C] border border-[#26334D] p-8">
        <h1 className="text-3xl font-extrabold tracking-tight">Forgot your password?</h1>
        {sent ? (
          <div data-testid="forgot-sent" className="mt-6 space-y-4">
            <MailCheck className="h-10 w-10 text-[#00E5A3]" />
            <p className="text-slate-300 text-sm">{sent}</p>
            <p className="text-slate-500 text-xs">Don't see it? Check your spam folder, or try again in a minute.</p>
            <Button data-testid="forgot-resend" variant="outline" onClick={() => setSent("")} className="w-full h-11 rounded-full border-[#26334D] bg-transparent">Use a different email</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <p className="text-slate-400 text-sm">Enter the email you signed up with and we'll send you a link to choose a new one.</p>
            <div className="space-y-2">
              <Label htmlFor="forgot-email" className="text-slate-300">Email</Label>
              <Input id="forgot-email" data-testid="forgot-email-input" type="email" required placeholder="you@example.com" value={email}
                onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl bg-[#0B0F19] border-[#26334D] focus-visible:ring-[#FF3B6B]" />
            </div>
            {error && <p data-testid="forgot-error" className="text-sm text-[#FF7A7A]">{error}</p>}
            <Button data-testid="forgot-submit-button" disabled={busy} type="submit" className="w-full h-12 rounded-full bg-[#FF3B6B] hover:bg-[#E02E5A] text-white font-semibold">
              {busy ? "Sending…" : "Email me a reset link"}
            </Button>
          </form>
        )}
        <p className="text-sm text-slate-400 mt-6 text-center">
          Remembered it? <Link data-testid="forgot-back-to-login" to="/login" className="text-[#FF3B6B] font-semibold">Log in</Link>
        </p>
      </div>
    </main>
  );
}
